import { Route } from '@angular/router';
import { getNavigationGroup } from '../../core/config/app-navigation';
import { pageAccessGuard } from '../../core/guards/page-access.guard';

const navigation = getNavigationGroup('gestion-comercial');

const routeLoaders = {
  prospectos: () =>
    import('./pages/prospectos/prospectos.page').then((m) => m.ProspectosPage),
  socios: () => import('./pages/socios/socios.page').then((m) => m.SociosPage),
  'ex-socios': () => import('./pages/ex-socios/ex-socios.page').then((m) => m.ExSociosPage),
  'base-de-datos': () =>
    import('./pages/base-de-datos/base-de-datos.page').then((m) => m.BaseDeDatosPage),
  distribucion: () =>
    import('./pages/distribucion/distribucion.page').then((m) => m.DistribucionPage),
};

export const gestionComercialRoutes: Route[] = navigation.items.map((item) => {
  const loadComponent = routeLoaders[item.key as keyof typeof routeLoaders];

  if (!loadComponent) {
    throw new Error(`No loadComponent configured for gestion-comercial route "${item.key}".`);
  }

  return {
    path: item.path.replace(/^\//, ''),
    data: {
      pageKey: item.pageKey,
      title: item.title,
      description: item.description,
    },
    canActivate: [pageAccessGuard],
    loadComponent,
  };
});
